import * as Blockly from 'blockly';

export type ScratchExtensionGenerator = Blockly.Generator & {
  forBlock: Record<string, (block: Blockly.Block, generator: Blockly.Generator) => string | [string, number]>;
  ORDER_NONE: number;
  ORDER_FUNCTION_CALL: number;
};

const createListField = () => new Blockly.FieldVariable('列表', undefined, ['ScratchList'], 'ScratchList');

export function registerScratchExtensionBlocks(): void {
  const statement = (type: string, label: string, colour: number, configure?: (block: Blockly.Block) => void) => {
    Blockly.Blocks[type] = {
      init() {
        this.appendDummyInput().appendField(label);
        configure?.(this);
        this.setPreviousStatement(true, null);
        this.setNextStatement(true, null);
        this.setColour(colour);
      },
    };
  };
  const value = (type: string, label: string, output: string, colour: number, configure?: (block: Blockly.Block) => void) => {
    Blockly.Blocks[type] = {
      init() {
        this.appendDummyInput().appendField(label);
        configure?.(this);
        this.setOutput(true, output);
        this.setColour(colour);
      },
    };
  };

  Blockly.Blocks.scratch_list_add = { init() {
    this.appendValueInput('ITEM').appendField('添加');
    this.appendDummyInput().appendField('到列表').appendField(createListField(), 'LIST');
    this.setPreviousStatement(true, null); this.setNextStatement(true, null); this.setColour(260);
  }};
  Blockly.Blocks.scratch_list_delete = { init() {
    this.appendValueInput('INDEX').setCheck('Number').appendField('删除列表');
    this.appendDummyInput().appendField(createListField(), 'LIST').appendField('第几项');
    this.setPreviousStatement(true, null); this.setNextStatement(true, null); this.setColour(260);
  }};
  Blockly.Blocks.scratch_list_insert = { init() {
    this.appendValueInput('ITEM').appendField('插入');
    this.appendValueInput('INDEX').setCheck('Number').appendField('到列表');
    this.appendDummyInput().appendField(createListField(), 'LIST').appendField('第几项');
    this.setPreviousStatement(true, null); this.setNextStatement(true, null); this.setColour(260);
  }};
  Blockly.Blocks.scratch_list_replace = { init() {
    this.appendValueInput('INDEX').setCheck('Number').appendField('替换列表');
    this.appendDummyInput().appendField(createListField(), 'LIST').appendField('第几项为');
    this.appendValueInput('ITEM');
    this.setPreviousStatement(true, null); this.setNextStatement(true, null); this.setColour(260);
  }};
  value('scratch_list_item', '列表项目', 'String', 260, (block) => {
    block.appendDummyInput().appendField(createListField(), 'LIST');
    block.appendValueInput('INDEX').setCheck('Number').appendField('第几项');
  });
  value('scratch_list_length', '列表长度', 'Number', 260, (block) => block.appendDummyInput().appendField(createListField(), 'LIST'));
  value('scratch_list_index_of', '列表项目序号', 'Number', 260, (block) => {
    block.appendDummyInput().appendField(createListField(), 'LIST');
    block.appendValueInput('ITEM').appendField('项目');
  });
  value('scratch_list_contents', '列表内容', 'String', 260, (block) => block.appendDummyInput().appendField(createListField(), 'LIST'));
  Blockly.Blocks.scratch_list_contains = { init() {
    this.appendDummyInput().appendField('列表').appendField(createListField(), 'LIST').appendField('包含');
    this.appendValueInput('ITEM'); this.setOutput(true, 'Boolean'); this.setColour(260);
  }};
  statement('scratch_list_clear', '清空列表', 260, (block) => block.appendDummyInput().appendField(createListField(), 'LIST'));
  statement('scratch_list_show', '显示列表监视器', 260, (block) => block.appendDummyInput().appendField(createListField(), 'LIST'));
  statement('scratch_list_hide', '隐藏列表监视器', 260, (block) => block.appendDummyInput().appendField(createListField(), 'LIST'));

  statement('scratch_pen_clear', '全部擦除', 120);
  statement('scratch_pen_stamp', '图章', 120);
  statement('scratch_pen_down', '落笔', 120);
  statement('scratch_pen_up', '抬笔', 120);
  Blockly.Blocks.scratch_pen_set_color = { init() {
    this.appendValueInput('COLOR').appendField('将画笔颜色设为');
    this.setPreviousStatement(true, null); this.setNextStatement(true, null); this.setColour(120);
  }};
  Blockly.Blocks.scratch_pen_change_size = { init() {
    this.appendValueInput('SIZE').setCheck('Number').appendField('将画笔粗细增加');
    this.setPreviousStatement(true, null); this.setNextStatement(true, null); this.setColour(120);
  }};
  Blockly.Blocks.scratch_pen_set_size = { init() {
    this.appendValueInput('SIZE').setCheck('Number').appendField('将画笔粗细设为');
    this.setPreviousStatement(true, null); this.setNextStatement(true, null); this.setColour(120);
  }};

  Blockly.Blocks.scratch_event_when_clone_start = { init() {
    this.appendDummyInput().appendField('当作为克隆体启动时');
    this.setNextStatement(true, null); this.setColour(45);
  }};

  Blockly.Blocks.scratch_music_play_note = { init() {
    this.appendValueInput('NOTE').setCheck('Number').appendField('演奏音符');
    this.appendValueInput('BEATS').setCheck('Number').appendField('拍');
    this.setPreviousStatement(true, null); this.setNextStatement(true, null); this.setColour(330);
  }};
  Blockly.Blocks.scratch_music_rest = { init() {
    this.appendValueInput('BEATS').setCheck('Number').appendField('休止');
    this.appendDummyInput().appendField('拍'); this.setPreviousStatement(true, null); this.setNextStatement(true, null); this.setColour(330);
  }};
  Blockly.Blocks.scratch_music_play_drum = { init() {
    this.appendValueInput('DRUM').setCheck('Number').appendField('演奏鼓声');
    this.appendValueInput('BEATS').setCheck('Number').appendField('拍');
    this.setPreviousStatement(true, null); this.setNextStatement(true, null); this.setColour(330);
  }};
  Blockly.Blocks.scratch_music_set_instrument = { init() {
    this.appendValueInput('INSTRUMENT').setCheck('Number').appendField('将乐器设为');
    this.setPreviousStatement(true, null); this.setNextStatement(true, null); this.setColour(330);
  }};
  Blockly.Blocks.scratch_music_set_tempo = { init() {
    this.appendValueInput('TEMPO').setCheck('Number').appendField('将演奏速度设为');
    this.setPreviousStatement(true, null); this.setNextStatement(true, null); this.setColour(330);
  }};
  Blockly.Blocks.scratch_music_change_tempo = { init() {
    this.appendValueInput('TEMPO').setCheck('Number').appendField('将演奏速度增加');
    this.setPreviousStatement(true, null); this.setNextStatement(true, null); this.setColour(330);
  }};
  value('scratch_music_tempo', '演奏速度', 'Number', 330);

  Blockly.Blocks.scratch_video_turn = { init() {
    this.appendDummyInput().appendField('将摄像头').appendField(new Blockly.FieldDropdown([['打开', 'on'], ['关闭', 'off'], ['镜像', 'mirror']]), 'STATE');
    this.setPreviousStatement(true, null); this.setNextStatement(true, null); this.setColour(180);
  }};
  Blockly.Blocks.scratch_video_set_transparency = { init() {
    this.appendValueInput('TRANSPARENCY').setCheck('Number').appendField('将视频透明度设为');
    this.setPreviousStatement(true, null); this.setNextStatement(true, null); this.setColour(180);
  }};
  value('scratch_video_motion', '视频运动量', 'Number', 180);
  value('scratch_video_direction', '视频运动方向', 'Number', 180);

  Blockly.Blocks.scratch_hardware_when_button = { init() {
    this.appendDummyInput().appendField('当硬件按键').appendField(new Blockly.FieldDropdown([['A', 'a'], ['B', 'b']]), 'BUTTON').appendField('按下');
    this.setNextStatement(true, null); this.setColour(200);
  }};
  Blockly.Blocks.scratch_hardware_display_text = { init() {
    this.appendValueInput('TEXT').appendField('硬件显示文本');
    this.setPreviousStatement(true, null); this.setNextStatement(true, null); this.setColour(200);
  }};
  value('scratch_hardware_acceleration', '硬件加速度', 'Number', 200, (block) => block.appendDummyInput().appendField(new Blockly.FieldDropdown([['X', 'x'], ['Y', 'y'], ['Z', 'z']]) as Blockly.Field<string | undefined>, 'AXIS'));
}

const code = (generator: Blockly.Generator, block: Blockly.Block, name: string, fallback: string) =>
  generator.valueToCode(block, name, (generator as ScratchExtensionGenerator).ORDER_NONE) || fallback;
const listName = (block: Blockly.Block) => JSON.stringify((block.getField('LIST') as Blockly.FieldVariable | null)?.getVariable()?.name || '列表');

export function registerScratchExtensionGenerators(generator: ScratchExtensionGenerator): void {
  generator.forBlock.scratch_list_add = (block, gen) => `scratchListAdd(${listName(block)}, ${code(gen, block, 'ITEM', '""')});\n`;
  generator.forBlock.scratch_list_delete = (block, gen) => `scratchListDelete(${listName(block)}, ${code(gen, block, 'INDEX', '1')});\n`;
  generator.forBlock.scratch_list_insert = (block, gen) => `scratchListInsert(${listName(block)}, ${code(gen, block, 'INDEX', '1')}, ${code(gen, block, 'ITEM', '""')});\n`;
  generator.forBlock.scratch_list_replace = (block, gen) => `scratchListReplace(${listName(block)}, ${code(gen, block, 'INDEX', '1')}, ${code(gen, block, 'ITEM', '""')});\n`;
  generator.forBlock.scratch_list_item = (block, gen) => [`scratchListItem(${listName(block)}, ${code(gen, block, 'INDEX', '1')})`, generator.ORDER_FUNCTION_CALL];
  generator.forBlock.scratch_list_length = (block) => [`scratchListLength(${listName(block)})`, generator.ORDER_FUNCTION_CALL];
  generator.forBlock.scratch_list_index_of = (block, gen) => [`scratchListIndexOf(${listName(block)}, ${code(gen, block, 'ITEM', '""')})`, generator.ORDER_FUNCTION_CALL];
  generator.forBlock.scratch_list_contents = (block) => [`scratchListContents(${listName(block)})`, generator.ORDER_FUNCTION_CALL];
  generator.forBlock.scratch_list_contains = (block, gen) => [`scratchListContains(${listName(block)}, ${code(gen, block, 'ITEM', '""')})`, generator.ORDER_FUNCTION_CALL];
  generator.forBlock.scratch_list_clear = (block) => `scratchListClear(${listName(block)});\n`;
  generator.forBlock.scratch_list_show = (block) => `scratchListSetVisible(${listName(block)}, true);\n`;
  generator.forBlock.scratch_list_hide = (block) => `scratchListSetVisible(${listName(block)}, false);\n`;
  generator.forBlock.scratch_pen_clear = () => 'scratchPenClear();\n';
  generator.forBlock.scratch_pen_stamp = () => 'scratchPenStamp();\n';
  generator.forBlock.scratch_pen_down = () => 'scratchPenDown();\n';
  generator.forBlock.scratch_pen_up = () => 'scratchPenUp();\n';
  generator.forBlock.scratch_pen_set_color = (block, gen) => `scratchPenSetColor(${code(gen, block, 'COLOR', '"#1f78d1"')});\n`;
  generator.forBlock.scratch_pen_change_size = (block, gen) => `scratchPenChangeSize(${code(gen, block, 'SIZE', '1')});\n`;
  generator.forBlock.scratch_pen_set_size = (block, gen) => `scratchPenSetSize(${code(gen, block, 'SIZE', '1')});\n`;
  generator.forBlock.scratch_event_when_clone_start = (block, gen) => `onCloneStart(async () => {\n${gen.blockToCode(block.getNextBlock()) || ''}});\n`;
  generator.forBlock.scratch_music_play_note = (block, gen) => `await scratchMusicPlayNote(${code(gen, block, 'NOTE', '60')}, ${code(gen, block, 'BEATS', '0.5')});\n`;
  generator.forBlock.scratch_music_rest = (block, gen) => `await scratchMusicRest(${code(gen, block, 'BEATS', '0.5')});\n`;
  generator.forBlock.scratch_music_play_drum = (block, gen) => `await scratchMusicPlayDrum(${code(gen, block, 'DRUM', '1')}, ${code(gen, block, 'BEATS', '0.25')});\n`;
  generator.forBlock.scratch_music_set_instrument = (block, gen) => `scratchMusicSetInstrument(${code(gen, block, 'INSTRUMENT', '1')});\n`;
  generator.forBlock.scratch_music_set_tempo = (block, gen) => `scratchMusicSetTempo(${code(gen, block, 'TEMPO', '60')});\n`;
  generator.forBlock.scratch_music_change_tempo = (block, gen) => `scratchMusicChangeTempo(${code(gen, block, 'TEMPO', '20')});\n`;
  generator.forBlock.scratch_music_tempo = () => ['scratchMusicTempo()', generator.ORDER_FUNCTION_CALL];
  generator.forBlock.scratch_video_turn = (block) => `await scratchVideoTurn(${JSON.stringify(block.getFieldValue('STATE') || 'on')});\n`;
  generator.forBlock.scratch_video_set_transparency = (block, gen) => `scratchVideoSetTransparency(${code(gen, block, 'TRANSPARENCY', '50')});\n`;
  generator.forBlock.scratch_video_motion = () => ['scratchVideoMotion()', generator.ORDER_FUNCTION_CALL];
  generator.forBlock.scratch_video_direction = () => ['scratchVideoDirection()', generator.ORDER_FUNCTION_CALL];
  generator.forBlock.scratch_hardware_when_button = (block, gen) => `onScratchHardwareButton(${JSON.stringify(block.getFieldValue('BUTTON') || 'a')}, async () => {\n${gen.blockToCode(block.getNextBlock()) || ''}});\n`;
  generator.forBlock.scratch_hardware_display_text = (block, gen) => `scratchHardwareDisplay(${code(gen, block, 'TEXT', '""')});\n`;
  generator.forBlock.scratch_hardware_acceleration = (block) => [`scratchHardwareAcceleration(${JSON.stringify(block.getFieldValue('AXIS') || 'x')})`, generator.ORDER_FUNCTION_CALL];
}
